import rest from '../rest';
import auth from '../auth';

const serverUrl = process.env.VUE_APP_QAP_API_SERVER_URL;

const tokenRequest = {
  scopes: ['api://25a33c3c-a16e-4905-9220-26e8b8c75088/User.ReadWrite'], // QAP API Scope
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

export default {
  async getBatchInfo(farm) {
    try {
      const url = `${serverUrl}/biotech/gethealthbleedbatchinfo?farmname=${farm}`;
      const options = await auth.getOptions(tokenRequest, 'GET');

      return await rest.call(url, options);
    } 
    catch(e) {
      throw new Error(`Unable to retrieve QAP Batch Information for ${farm} (${e.message})`)
    }
  }
}